module.exports = __webpack_public_path__ + "static/txtling1-300x266-41b9504a9583aa9b7a5edb9991997caa.png";